import React, {useCallback} from "react";
import {useParams} from "react-router";
import {useDiaEditor} from "../../components/DiaEditor";
import {NonIdealState} from "../../components/NonIdealState";
import WaitSpinner from "../../components/wait-spinner";
import {
    CreateDistributorMutation,
    Distributor,
    GetDistributorQueryResult,
    UpdateDistributorMutation,
    UpdateDistributorMutationResult,
    useCreateDistributorMutation,
    useGetDistributorQuery,
    useUpdateDistributorMutation
} from "../../generated/graphql";
import DistributorForm from "./Form";
import {uniqueId} from "../../utils";


function blankValues(): Distributor {
    return {
        id:uniqueId(),
        name:'',
        email:''
    };
}



export function DistributorEditor() {
    const params = useParams();
    const isNew = (params.id=='new');
    const query = useGetDistributorQuery({variables:{id:params.id??''},skip:isNew});
    const [saveMutation,saveResult] = useUpdateDistributorMutation();
    const [createMutation,createResult] = useCreateDistributorMutation();
    const save = useCallback(({values})=>{
        return saveMutation({variables:{input:values}});
    },[]);
    const create = useCallback(({values})=>{
        return createMutation({variables:{input:values}});
    },[]);
    const getValue = useCallback((result:GetDistributorQueryResult)=>{
        return result?.data?.distributor;
    },[]);
    const getSaveValue = useCallback((result:UpdateDistributorMutationResult)=>{
        return result?.data?.updateDistributor;
    },[]);
    const getCreateRedirect = useCallback(({data,baseUrl})=>{
        return baseUrl+(data?.data?.createDistributor?.id);
    },[]);

    const data = useDiaEditor<Distributor,GetDistributorQueryResult,CreateDistributorMutation,UpdateDistributorMutation>({save,saveResult,create,createResult,query:query,
        baseUrl:'/database/distributors/',
        blankValues:blankValues,
        label:'Distributors',
        permission:'distributors',
        getValue:getValue,
        getSaveValue:getSaveValue,
        getCreateRedirect:getCreateRedirect
    });

    if (query.error) {
        return <NonIdealState
            severity="error"
            title="An error has occurred"
            message="GraphQL error encountered"
        />;
    }
    if(data.form.status=='loading') {
        return <WaitSpinner variant="panel"/>;
    }
    return <>{data.confirmation}<DistributorForm waiting={data.waiting} diaForm={data.form} /></>;
}